import { SearchShop } from '@remodeling/shop';
import Link from 'next/link';
import React from 'react';
import { CustomOverlayMap } from 'react-kakao-maps-sdk';
import styled from 'styled-components';
import OverlayBox from './OverlayBox';

interface MarkerProps {
  item: SearchShop;
  hoverItem: number | null;
  setHoverItem?: (num: number | null) => void;
}

const Marker = ({ item, hoverItem, setHoverItem, ...props }: MarkerProps) => {
  // 매장 위치정보 보내기

  return (
    <Link href={`/shop/${item.id}`} passHref>
      <OverlayContainer
        onMouseOver={() => setHoverItem && setHoverItem(item.id)}
        onMouseLeave={() => setHoverItem && setHoverItem(null)}
      >
        <CustomOverlayMap
          key={`${item.address.coordinates.latitude}-${item.address.coordinates.longitude}`}
          position={{
            lat: item.address.coordinates.latitude,
            lng: item.address.coordinates.longitude,
          }}
          zIndex={item.id === hoverItem ? 999 : 99}
        >
          {/* 커스텀 오버레이에 표시할 내용입니다  */}
          <OverlayBox
            item={item}
            currentHover={hoverItem as number}
            {...props}
          />
        </CustomOverlayMap>
      </OverlayContainer>
    </Link>
  );
};

export default Marker;

const OverlayContainer = styled.div``;
